import React from 'react'
import PropTypes from 'prop-types'
import { fnum } from '../../utils/utils'
import moment from 'moment'
import axios from 'axios'
import { servAddr } from '../../servAddr'
import { rubles } from 'rubles'

class InvoiceForm extends React.Component {

  state = {errors: {}}

  componentWillMount(){
    window.scrollTo(0, 0);
  }

  backToOrder = e => {
    e.preventDefault();
    this.context.router.goBack();
  }

  exportClick = () => {
    this.setState({errors: {}});
    const { invc } = this.props;
    const fileName = invc.invc_inv ? (
      invc.invc_act ? 'Счет-акт' : 'Счет'
    ) : 'Акт';
    const invNum = invc.invc_num + '/' + invc.invc_year.toString().substring(2);
    const invDate = moment(invc.invc_billed).format('L');
    axios({
      method: 'get',
      url: servAddr + 'excel_invoice?id='+this.props.invcId,
      responseType: 'arraybuffer'
    }).then(response => {
      let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName} ${invNum} от ${invDate}.xls`;
      link.click();
    }, (err) => {
      this.setState({
        errors: err.response.data.errors || {form: "Ошибка " + err.response.status}
      });
    });
  }

  render() {
    if(this.props.comprights.indexOf(this.props.order.order_comp1_id) === -1){
      return(<div>Нет доступа</div>);
    }
    const { requs, invc } = this.props;
    const { errors } = this.state;

    const myRequ = requs[invc.invc_requ1_id];
    const requ = requs[invc.invc_requ_id];

    const inv =
      <div className="printPage">
        <p><u><b>Исполнитель:</b></u> {myRequ.requ_long}</p>
        <p>Адрес: {myRequ.requ_addr}</p>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>ИНН {myRequ.requ_inn}</td>
              <td></td>
              <td>Сч.&nbsp;№</td>
              <td>{myRequ.requ_cacc}</td>
            </tr>
            <tr>
              <td colSpan="2" rowSpan="2">
                Банк исполнителя: {myRequ.requ_bname}<br />{myRequ.requ_baddr}
              </td>
              <td>БИК</td>
              <td>{myRequ.requ_bik}</td>
            </tr>
            <tr>
              <td>К/сч.&nbsp;№</td>
              <td>{myRequ.requ_bacc}</td>
            </tr>
          </tbody>
        </table>
        <p><u><b>Заказчик:</b></u> {requ.requ_long}</p>
        <p>Адрес: {requ.requ_addr}</p>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>ИНН {requ.requ_inn}</td>
              <td>КПП {requ.requ_kpp}</td>
              <td>Сч.&nbsp;№</td>
              <td>{requ.requ_cacc}</td>
            </tr>
            <tr>
              <td colSpan="2" rowSpan="2">
                Банк заказчика: {requ.requ_bname}<br />{requ.requ_baddr}
              </td>
              <td>БИК</td>
              <td>{requ.requ_bik}</td>
            </tr>
            <tr>
              <td>К/сч.&nbsp;№</td>
              <td>{requ.requ_bacc}</td>
            </tr>
          </tbody>
        </table>
        <h3 className="text-center">
          Счет №{invc.invc_num}/{invc.invc_year.toString().substring(2)}
          {' '}от {moment(invc.invc_billed).format('L')}
        </h3>
        <table className="table table-bordered bottom-buffer2">
          <tbody>
            <tr>
              <td>№</td>
              <td>Наименование товара/услуги</td>
              <td>Ед. изм.</td>
              <td>Кол-во</td>
              <td>Цена</td>
              <td>Сумма</td>
            </tr>
            <tr>
              <td>1</td>
              <td>{invc.invc_text}</td>
              <td>Услуга</td>
              <td>1</td>
              <td>{fnum(invc.invc_sum)}</td>
              <td>{fnum(invc.invc_sum)}</td>
            </tr>
            <tr>
              <td className="text-right" colSpan="5">Итого</td>
              <td>{fnum(invc.invc_sum)}</td>
            </tr>
            <tr>
              <td className="text-right" colSpan="5">Без налога (НДС)</td>
              <td> - </td>
            </tr>
            <tr>
              <td className="text-right" colSpan="5">Всего к оплате</td>
              <td>{fnum(invc.invc_sum)}</td>
            </tr>
          </tbody>
        </table>
        <p className="bottom-buffer2"><b>Всего наименований на сумму {rubles(invc.invc_sum)}</b></p>
        <div className="row bottom-buffer">
          <div className="col-xs-6">Руководитель предприятия</div>
          <div className="col-xs-6">{myRequ.requ_dir}</div>
        </div>
        <div className="row">
          <div className="col-xs-6">Главный бухгалтер</div>
          <div className="col-xs-6">{myRequ.requ_buh}</div>
        </div>
      </div>;

    const act =
      <div className="printPage">
        <p><u><b>Исполнитель:</b></u> {myRequ.requ_long}</p>
        <p>Адрес: {myRequ.requ_addr}</p>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>ИНН {myRequ.requ_inn}</td>
              <td></td>
              <td>Сч.&nbsp;№</td>
              <td>{myRequ.requ_cacc}</td>
            </tr>
            <tr>
              <td colSpan="2" rowSpan="2">
                Банк исполнителя: {myRequ.requ_bname}<br />{myRequ.requ_baddr}
              </td>
              <td>БИК</td>
              <td>{myRequ.requ_bik}</td>
            </tr>
            <tr>
              <td>К/сч.&nbsp;№</td>
              <td>{myRequ.requ_bacc}</td>
            </tr>
          </tbody>
        </table>
        <p><u><b>Заказчик:</b></u> {requ.requ_long}</p>
        <p>Адрес: {requ.requ_addr}</p>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>ИНН {requ.requ_inn}</td>
              <td>КПП {requ.requ_kpp}</td>
              <td>Сч.&nbsp;№</td>
              <td>{requ.requ_cacc}</td>
            </tr>
            <tr>
              <td colSpan="2" rowSpan="2">
                Банк заказчика: {requ.requ_bname}<br />{requ.requ_baddr}
              </td>
              <td>БИК</td>
              <td>{requ.requ_bik}</td>
            </tr>
            <tr>
              <td>К/сч.&nbsp;№</td>
              <td>{requ.requ_bacc}</td>
            </tr>
          </tbody>
        </table>
        <h3 className="text-center">
          Акт №{invc.invc_num}/{invc.invc_year.toString().substring(2)}
          {' '}от {moment(invc.invc_billed).format('L')}
        </h3>
        <table className="table table-bordered bottom-buffer2">
          <tbody>
            <tr>
              <td>№</td>
              <td>Наименование товара/услуги</td>
              <td>Ед. изм.</td>
              <td>Кол-во</td>
              <td>Цена</td>
              <td>Сумма</td>
            </tr>
            <tr>
              <td>1</td>
              <td>{invc.invc_text}</td>
              <td>Услуга</td>
              <td>1</td>
              <td>{fnum(invc.invc_sum)}</td>
              <td>{fnum(invc.invc_sum)}</td>
            </tr>
            <tr>
              <td className="text-right" colSpan="5">Итого</td>
              <td>{fnum(invc.invc_sum)}</td>
            </tr>
            <tr>
              <td className="text-right" colSpan="5">Без налога (НДС)</td>
              <td> - </td>
            </tr>
            <tr>
              <td className="text-right" colSpan="5">Всего к оплате</td>
              <td>{fnum(invc.invc_sum)}</td>
            </tr>
          </tbody>
        </table>
        <p className="bottom-buffer2"><b>
          <i>Всего наименований на сумму {rubles(invc.invc_sum)}</i>
        </b></p>
        <p className="bottom-buffer2">
          <b>Вышеперечисленные услуги выполнены полностью и в срок.
          Заказчик претензий по объему, качеству и срокам оказания услуг не имеет.</b>
        </p>
        <table style={{width:'100%'}}>
          <tbody>
            <tr>
              <td style={{padding:"8px"}} className="text-right">Исполнитель</td>
              <td style={{padding:"8px",borderBottom:"1px solid"}}></td>
              <td style={{padding:"8px",width:"10%"}}></td>
              <td style={{padding:"8px"}} className="text-right">Заказчик</td>
              <td style={{padding:"8px",borderBottom:"1px solid"}}></td>
              <td style={{padding:"8px",width:"10%"}}></td>
            </tr>
            <tr>
              <td style={{padding:"8px"}}></td>
              <td style={{padding:"8px"}} className="text-center">Подпись</td>
              <td style={{padding:"8px"}}></td>
              <td style={{padding:"8px"}}></td>
              <td style={{padding:"8px"}} className="text-center">Подпись</td>
              <td style={{padding:"8px"}}></td>
            </tr>
            <tr>
              <td style={{padding:"8px"}}></td>
              <td style={{padding:"8px"}} className="text-center">М.П.</td>
              <td style={{padding:"8px"}}></td>
              <td style={{padding:"8px"}}></td>
              <td style={{padding:"8px"}} className="text-center">М.П.</td>
              <td style={{padding:"8px"}}></td>
            </tr>
          </tbody>
        </table>
      </div>;

    return (
      <div>
        <div className="form-group hidden-print">
          <button className="btn btn-default"
            onClick={this.backToOrder}>
            Назад
          </button>{" "}
          <button className="btn btn-default"
            onClick={this.exportClick}>
            Экспорт в Excel
          </button>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </div>
        <div className="toPrint">
          {invc.invc_inv ? inv : []}
          {invc.invc_act ? act : []}
        </div>
      </div>
    );
  }
}

InvoiceForm.contextTypes = {
  router: PropTypes.object.isRequired
}

export default InvoiceForm;



// WEBPACK FOOTER //
// ./src/components/invoice/InvoiceForm.js